import './EditableInput.css';
import { Input } from 'reactstrap';
import { forwardRef, useEffect, useMemo, useRef, useState } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import Toast from '../../Toast/Toast';
import debounce from 'lodash.debounce';
import { FaCheck } from 'react-icons/fa6';
import Fetch from '../../../../../util/core/Fetch';

const CustomEditableInput = forwardRef((props, ref) => {
  const editableInputRef = useRef(null);

  const [saved, setSaved] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(props.value);

  const className = useMemo(() => {
    return `${!inputValue ? 'input-empty' : ''} ${saved ? 'input-saved' : ''}`;
  }, [saved, inputValue]);

  const handleChange = async (element) => {
    const value = element.target.value;
    setInputValue(value);
  };

  const handleSubmit = async (event) => {
    let change;

    Toast.options.preventDuplicates = true;

    if (event.key === 'Tab') {
      handleFocusNextInput(event);
    }

    if (event.key === 'Enter' || event.key === 'Tab' || event.key === 'Blur') {
      const item = JSON.parse(props.item);
      const column = props.column;

      try {
        if (!inputValue) {
          Toast.error(`Campo vazio, preencha antes de salvar.`);
          return;
        }

        if (!!!props.onChange && props.endpointSave) {
          change = await handleDefaultSubmit(item, column, inputValue);
        } else {
          change = await props.onChange(item, column, inputValue);
        }

        if (!change) {
          Toast.error(
            `Erro ao salvar valor '${inputValue}' na linha ${
              props.index + 1
            } da tabela.`
          );
          return;
        }

        Toast.success(
          `Valor: '${inputValue}' salvo com sucesso na linha ${
            props.index + 1
          }!`
        );

        await handleSaveFeedback();
      } catch (error) {
        console.log(error);

        return false;
      }
    }
  };

  const handleFocusNextInput = (event) => {
    event.preventDefault();

    const inputs = document.querySelectorAll('.editable-input.input-editing');
    const currentIndex = Array.from(inputs).indexOf(event.target);

    if (currentIndex !== -1 && currentIndex < inputs.length - 1) {
      const previousInput = inputs[currentIndex];
      const nextInput = inputs[currentIndex + 1];

      previousInput.readOnly = true;
      nextInput.readOnly = false;

      nextInput.focus();
    }
  };

  const handleEnableEditing = () => {
    setSaved(false);
    setIsEditing(true);
  };

  const handleDisableEditing = () => {
    setIsEditing(false);
    setSaved(false);
  };

  const handleBlur = async (element) => {
    const formattedElement = {...element, key: "Blur"};
    await handleSubmit(formattedElement);
    await handleSaveFeedback();
  };

  const handleSaveFeedback = async () => {
    setSaved(true);

    const resetSave = debounce(() => {
      setSaved(false);
      handleDisableEditing();
    }, 800);

    resetSave();
  };

  const handleFocus = () => setIsEditing(true);

  const handleDefaultSubmit = async (item, column, value) => {
    try {
      await Fetch.put(props.endpointSave, {
        ...item,
        [column.column]: value,
      });

      return true;
    } catch (e) {
      console.log(e);

      return false;
    }
  };

  useEffect(() => {
    setInputValue(props.value);
  }, [props.value]);

  return (
    <div className={'editable-input content'}>
      <Input
        value={inputValue}
        type={props.type}
        name={props.name}
        ref={editableInputRef}
        id={`id_${props.name}`}
        readOnly={!isEditing}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        onKeyDown={handleSubmit}
        className={`editable-input input-editing ${className}`}
        autoFocus={!!props.autoFocus}
        maxLength={props.maxLength}
        onDoubleClick={handleEnableEditing}
      />

      {saved && <FaCheck color='#007745' size={18} />}

      {isEditing && !saved && (
        <button
          className={'editable-input button-close-editing'}
          onClick={handleDisableEditing}
        >
          <IoCloseSharp />
        </button>
      )}
    </div>
  );
});

export default CustomEditableInput;
